import { h } from 'preact'
import classnames from 'classnames'
import { CARD_TYPES } from '../../../constants/card'
import VisaLogo from '../../../assets/icons/Visa-Logo.svg'
import MastercardLogo from '../../../assets/icons/Mastercard-Logo.svg'
import MaestroLogo from '../../../assets/icons/Maestro-Logo.svg'
import AmericanExpressLogo from '../../../assets/icons/American-Express-Logo.svg'
import './styles.scss'
import { CardDetails } from '../../../types'
import { useTranslations } from '../../../hooks/useTranslations'

const logoMap = new Map([
  [CARD_TYPES.amex, AmericanExpressLogo],
  [CARD_TYPES.visa, VisaLogo],
  [CARD_TYPES.masterCard, MastercardLogo],
  [CARD_TYPES.maestro, MaestroLogo],
])

function SavedCard({
  cardBrand,
  maskedCardNumber,
  expiryYear,
  cardholderName,
  isExpired,
}) {
  const l10n = useTranslations()

  const logo = logoMap.get(cardBrand?.toLowerCase())
  const expirationDate = `•• / ${expiryYear}`

  const classNames = classnames('saved-card', { expired: isExpired })

  return (
    <div className={classNames} data-testid={`saved-card-${maskedCardNumber}`}>
      <div className="saved-card__logo">
        {logo && (
          <img
            data-testid="card-logo-icon"
            src={logo}
            alt={l10n.t('Logo for: ') + cardBrand}
          />
        )}
      </div>
      <div className="saved-card__info">
        <span data-testid="masked-card">{maskedCardNumber}</span>
        <span data-testid="expiration-date">
          {l10n.t('Exp')}: {expirationDate}
        </span>
        <span data-testid="cardholder-name">{cardholderName}</span>
        {isExpired && (
          <span data-testid="expired-description" className="expired">
            {l10n.t('This card has expired')}
          </span>
        )}
      </div>
    </div>
  )
}

SavedCard.propTypes = CardDetails

export default SavedCard
